import request from "./http";

class SectionRepository
{
    async getAll() {
        const path = "sections";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async create(role) {
        const path = "sections/create";
        const method = "POST";
        const data = role;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(role) {
        const path = "sections/edit";
        const method = "POST";
        const data = role;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async gridview(query) {
        const path = "sections/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async getOneById(id) {
        const path = "sections/get";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }
}
export default SectionRepository;